function truncateText(text, n = 30) {
  if (typeof text !== 'string') return '';
  return text.length > n ? `${text.slice(0, n)}…` : text;
}

export default truncateText;
